import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface RaceBoxSelectionLoaderPropsType {
    variant: DefaultComponentVariantType | null;
}

export const RaceBoxWrapper = withConfig(theme => styled('div', { label: 'RaceBoxWrapper' })<RaceBoxSelectionLoaderPropsType>`
    padding: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.padding.small : theme.star.padding.medium};
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`);

export const HorseInfoWrapper = withConfig(theme => styled('div', { label: 'HorseInfoWrapper' })<RaceBoxSelectionLoaderPropsType>`
    padding: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? `${theme.star.padding.medium} ${theme.star.padding.xMedium}`: '0'};
    display: flex;
    justify-content: space-between;
    align-items: center;
`);
